import {ref} from 'vue';

export default {
    install: (app, options) => {
        const profileUser = ref(null);
        const profileUserChannel = ref(null);

        const loadProfileUser = () => {
            window.lazy_axios.get('/dashboard/profile/user')
                .then((response) => {
                    if (response.data.user) {
                        profileUser.value = response.data.user;

                        if (window.Echo) {
                            profileUserChannel.value = window.Echo.private(`users.${response.data.user.id}`);
                        }
                    }
                });
        };

        const resetAll = () => {
            profileUser.value = null;
            profileUserChannel.value = null;
        };

        app.provide('profileUser', profileUser);
        app.provide('profileUserChannel', profileUserChannel);
        app.provide('loadProfileUser', loadProfileUser);
        app.provide('profileUserProvider', {
            profileUser,
            profileUserChannel,
            loadProfileUser,
            resetAll,
        });
    },
}
